import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./List";
import Add from "./Add";

function SubLocationBins({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/add`} component={Add} />
    </Switch>
  );
}

export { SubLocationBins };
